var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1859_32322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.168 12.0001C13.168 14.8598 10.8656 17.178 8.02537 17.178C5.18522 17.178 2.88281 14.8598 2.88281 12.0001C2.88281 9.14047 5.18522 6.82227 8.02542 6.82227C10.8656 6.82227 13.168 9.14047 13.168 12.0001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8096 12C18.8096 14.6919 17.6584 16.8741 16.2383 16.8741C14.8182 16.8741 13.667 14.6919 13.667 12C13.667 9.30815 14.8182 7.12598 16.2383 7.12598C17.6584 7.12598 18.8096 9.30815 18.8096 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1173 12.0003C21.1173 14.4121 20.7124 16.3672 20.2129 16.3672C19.7135 16.3672 19.3086 14.4121 19.3086 12.0003C19.3086 9.58846 19.7134 7.6333 20.2129 7.6333C20.7124 7.6333 21.1173 9.58846 21.1173 12.0003Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1859_32322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.43fc14799d751d756867c8d5d5200bff.svg";
export { ForwardRef as ReactComponent };